import {
  PaymentLinkPublicApiService,
  OperationsApiService,
  ApiResponseDTOOperationFullDTO,
} from "@zenith/services/transactions";
import { OperationDTO } from "@zenith/services/transactions";

export async function pollPaymentStatus(
  operationId: string,
  isPaymentLink: boolean
): Promise<{
  status: OperationDTO.status;
  data?: any;
  error?: { internalCode: string; message: string };
}> {
  if (!operationId) throw new Error("Operation ID is required");

  try {
    const response: ApiResponseDTOOperationFullDTO = isPaymentLink
      ? await PaymentLinkPublicApiService.getOperationLongPolling1(operationId)
      : await OperationsApiService.getOperationLongPolling(operationId);

    // Handle payment link specific responses
    if (isPaymentLink && response.internalCode === "09") {
      return {
        status: OperationDTO.status.PENDING,
        error: {
          internalCode: response.internalCode,
          message: response.message ?? "Pending",
        },
      };
    }

    if (response.internalCode === "00" && response.data) {
      return {
        status: response.data.status as OperationDTO.status,
        data: response.data,
      };
    }

    // Handle payment link expired scenario
    if (isPaymentLink && response.internalCode === "ZENZ-CROSS-002") {
      return {
        status: OperationDTO.status.EXPIRED,
        error: {
          internalCode: response.internalCode,
          message: response.message ?? "Payment link expired",
        },
      };
    }

    console.warn("[pollPaymentStatus] Failed/unexpected response:", response);
    return {
      status: OperationDTO.status.FAILED,
      error: {
        internalCode: response.internalCode ?? "99",
        message: response.message ?? "Unknown error",
      },
    };
  } catch (err: any) {
    console.error("[pollPaymentStatus] Error caught:", err);
    return {
      status: OperationDTO.status.FAILED,
      error: {
        internalCode: "99",
        message: err?.message ?? "Unknown error",
      },
    };
  }
}
